import { defaultGuid } from '@equifinance/shared';
import {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useMemo,
  createContext,
} from 'react';

import { BrokerDetails } from './Broker';
import { useBroker } from './useBroker';

export const defaultBrokerDetails: BrokerDetails = {
  id: defaultGuid,
  firstName: '',
  surname: '',
  telephoneNumber: '',
  emailAddress: '',
  isAdmin: false,
};

export type BrokerContextType = {
  id: string,
  brokerDetails: BrokerDetails,
  setBrokerDetails: Dispatch<SetStateAction<BrokerDetails>>,
  fetchBroker(): Promise<void>,
}

const defaultBrokerContext: BrokerContextType = {
  id: defaultGuid,
  brokerDetails: defaultBrokerDetails,
  setBrokerDetails: () => { },
  fetchBroker: async () => { },
};

export const BrokerContext = createContext<BrokerContextType>(defaultBrokerContext);

export function useBrokerContext() {
  return useContext(BrokerContext);
}

export function BrokerProvider({ id, children }: PropsWithChildren<{ id: string }>) {
  const { brokerDetails, ...broker } = useBroker(id);

  const contextValue = useMemo(() => ({
    ...broker,
    brokerDetails,
    id,
  }), [id, brokerDetails]);

  return (
    <BrokerContext.Provider value={contextValue}>{children}</BrokerContext.Provider>
  );
}
